import { ObjectValueType } from '@shared/utils/type.utils';
export const SocialsType = {
  facebookUrl: 'Facebook',
  instagramUrl: 'Instagram',
  tiktokUrl: 'TikTok',
  xTwitterUrl: 'X',
  youtube: 'Youtube'
} as const;
export type SocialsType = ObjectValueType<typeof SocialsType>;